let thisDateMixin = {
    methods: {
        getDateNow: function() {
            let returnData = {
                year: this.$store.state.dateNow.getFullYear(),
                month: this.$store.state.dateNow.getMonth(),
                day: this.$store.state.dateNow.getDate(),
                hour: this.$store.state.dateNow.getHours(),
                minute: this.$store.state.dateNow.getMinutes(),
                second: this.$store.state.dateNow.getSeconds()
            }
        
            if (returnData.month < 10) {
                returnData.month = '0' + returnData.month
            }
            if (returnData.day < 10) {
                returnData.day = '0' + returnData.day
            }
            if (returnData.hour < 10) {
                returnData.hour = '0' + returnData.hour
            }
            if (returnData.minute < 10) {
                returnData.minute = '0' + returnData.minute
            }
            if (returnData.second < 10) {
                returnData.second = '0' + returnData.second
            }
        
            return returnData
        },
        getDateObj: function(timestamp) {
            let thisDate = new Date(timestamp)
            // console.log(thisDate)
            let returnData = {
                year: thisDate.getFullYear(),
                month: thisDate.getMonth(),
                day: thisDate.getDate(),
                hour: thisDate.getHours(),
                minute: thisDate.getMinutes(),
                second: thisDate.getSeconds()
            }
        
            if (returnData.month < 10) {
                returnData.month = '0' + returnData.month
            }
            if (returnData.day < 10) {
                returnData.day = '0' + returnData.day
            }
            if (returnData.hour < 10) {
                returnData.hour = '0' + returnData.hour
            }
            if (returnData.minute < 10) {
                returnData.minute = '0' + returnData.minute
            }
            if (returnData.second < 10) {
                returnData.second = '0' + returnData.second
            }
        
            return returnData
        },
        getDateStringFromDate: function(thisData, showTime = false, showSeconds = false) {
            if (thisData instanceof Date) {
                let thisYear = thisData.getFullYear()
                let thisMonth = thisData.getMonth() + 1
                if (thisMonth < 10) {
                    thisMonth = '0' + thisMonth
                }
                let thisDay = thisData.getDate()
                if (thisDay < 10) {
                    thisDay = '0' + thisDay
                }
        
                let thisReturnDate = `${thisDay}.${thisMonth}.${thisYear}`
                if (showTime) {
                    let thisHours = thisData.getHours()
                    if (thisHours < 10) {
                        thisHours = '0' + thisHours
                    }
                    let thisMinutes = thisData.getMinutes()
                    if (thisMinutes < 10) {
                        thisMinutes = '0' + thisMinutes
                    }
                    let thisSeconds = thisData.getSeconds()
                    if (thisSeconds < 10) {
                        thisSeconds = '0' + thisSeconds
                    }
        
                    thisReturnDate += ` ${thisHours}:${thisMinutes}`
                    if (showSeconds) {
                        thisReturnDate += `:${thisSeconds}`
                    }
                }
                return thisReturnDate
            } else return false
        }
    }
}

export default thisDateMixin